// @flow

import type {Action} from '../../types'
import type {SessionState} from '../types'
import type {SetErrorPayload} from '../actions/setError'

export function setErrorReducer(state: SessionState, action: Action<SetErrorPayload>): SessionState {

  return {
    ...state,
    error: action.payload.error,
  }
}
